let filterClass="col col-sm-6 col-lg-3 all ";

var assessmentsList= [{
    image: 'assets/images/banner/global-consulting.jpg',
    name: 'Global Consulting Readiness Assessment',
    type:filterClass+'Corporate',
    link: '/global-consulting-readiness'
},
{
    image: 'assets/images/banner/talent.jpg',
    name: 'Talent Optimizer Assessment',
    type:filterClass+'Corporate',
    link: '/talent-optimizer'
},
{
    image: 'assets/images/banner/governance.jpeg',
    name: 'IT Governance & Security Maturity Assessment',
    type:filterClass+'Security',
    link: '/it-governance-and-security-maturity'
},
{
    image: 'assets/images/banner/value-based-care.jpeg',
    name: 'Value Based Care Assessment',
    type:filterClass+'Health',
    link: '/value-based-care'
},
// {
//     image: 'assets/images/assessments/preview/data-privacy.jpg',
//     name: 'Privacy & Data Governance Maturity Assessment',
//     type:filterClass+'Graphic',
//     link: '/'
// },
// {
//     image: 'assets/images/assessments/preview/social-impact.jpg',
//     name: 'Social & Community Impact Assessment',
//     type:filterClass+'Illustration',
//     link: '#'
// }

]


export {assessmentsList};